import { Method } from 'axios';
import { Executable } from '../executable';
import { BambuProgram } from '../interfaces';

/**
 * The the programs that belong to the brand.
 */
export class GetPrograms extends Executable<BambuProgram[]> {
  public brandId?: number;

  public getMethod(): Method {
    return 'get';
  }

  public getResponse(apiResponse: any): BambuProgram[] {
    return apiResponse;
  }

  public getURLPath(tenantId?: string): string {
    if (!this.brandId) throw new Error('brandId is required');
    return `/${this.brandId}/programs`;
  }

  constructor(brandId: number) {
    super();
    this.brandId = brandId;
  }

  /**
   * getBody is used by the BambuClient to properly construct the request object body.
   * @returns Returns the expected body of the request utilizing the defined request attributes.
   */
  getBody(): undefined {
    return undefined;
  }

  /**
   * getRootPath is used by the BambuClient to properly construct the request call.
   * @returns The root path of the request
   */
  getRootPath(): string | undefined {
    return 'brands';
  }
}
